import React, { useState, useEffect } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import parse from "html-react-parser";
import Image from "components/Elements/Image/Image.tsx";
import ContactElementModal from "./ContactElementModal.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useUser } from "contexts/userContext/userContext.js";
import {
  ReactUpdateContact,
  SearchContactApi,
} from "components/Pages/Inbox/Contacts/ApiContactCalles.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";

const SearchContact = ({
  contactList,
  setContactList,
  countFavoritesUsers,
}) => {
  const { setModal, closeModal } = useModal();
  const { getTextByKey } = useContent();
  const { getUserData } = useUser();
  const userData = getUserData();
  const [iconSearch, setIconSearch] = useState("");
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [searchResult, setSearchResult] = useState(null);
  const [afterDelayDisplay, setAfterDelayDisplay] = useState(false);
  const [successResultSearch, setSuccessResultSearch] = useState(false);
  const defaultAvatar = "avatar_default_large";
  const [startSearch, setStartSearch] = useState(false);
  const [prevSearchValue, setPrevSearchValue] = useState("");

  const handleSearch = (e) => {
    setSearchInput(e);
    if (e) {
      setLoadingSearch(true);
    } else {
      cleanResult("");
      setLoadingSearch(false);
    }
  };

  useEffect(() => {
    if (searchInput && searchInput.length > 0) {
      //after 0.5 sec, start searching

      if (afterDelayDisplay && !startSearch) {
        if (prevSearchValue !== searchInput) {
          searchAction(searchInput);
        }
      }
    }
  }, [searchInput, afterDelayDisplay, prevSearchValue]);

  useEffect(() => {
    if (searchInput && searchInput.length > 0) {
      setTimeout(() => {
        setAfterDelayDisplay(true);
      }, 1000);
    }
  }, [searchInput]);

  //api call to search contact
  //Controller: ContactList
  //Function name: SearchContact
  //Params: UserId(userData.UserId), searchValue(searchInput), setSearchResult
  //Return: List of contacts
  const searchAction = (val) => {
    setLoadingSearch(true);
    setStartSearch(true);
    SearchContactApi({
      searchValue: val,
      setSearchResult: setSearchResult,
      setSuccessResultSearch: setSuccessResultSearch,
      setIconSearch: setIconSearch,
      setLoadingSearch: setLoadingSearch,
      setStartSearch: setStartSearch,
      setPrevSearchValue: setPrevSearchValue,
    });
  };

  const cleanResult = (text) => {
    setSuccessResultSearch(false);
    setSearchResult(null);
    setIconSearch("search");
  };

  const searchOrClose = () => {
    if (iconSearch === "x") {
      setSearchInput("");
      cleanResult("");
    } else {
      if (searchInput.length > 0) {
        searchAction(searchInput);
      }
    }
  };

  const renderResultSearching = () => {
    if (afterDelayDisplay) {
      return (
        <div className="result-search">
          {searchResult ? (
            searchResult.map((item, i) => (
              <div
                className="line-result contact-info "
                key={i}
                onClick={() => openEditModal(item)}
              >
                {renderContactLine(item)}
              </div>
            ))
          ) : (
            <div className="no-result">
              {parse(
                replaceTextNoResult(getTextByKey("contact-search-no-result"))
              )}
            </div>
          )}
        </div>
      );
    } else {
      return null;
    }
  };

  const getFirstTwoLettersOfEmail = (name) => {
    if (name) {
      //if the name contain space, get the first letter of each word else get the first letter of the name
      const nameArray = name.split(" ");
      if (nameArray.length > 1) {
        return (
          nameArray[0].charAt(0).toUpperCase() +
          nameArray[1].charAt(0).toUpperCase()
        );
      } else {
        return nameArray[0].charAt(0).toUpperCase();
      }
    }
  };

  const calculateBackgroundColor = (name) => {
    let backgroundColor = "#15b4d4";
    if (name) {
      const firstLetter = name.charAt(0);
      if (firstLetter) {
        //generate color from the firstLetter
        const firstLetterCode = firstLetter.charCodeAt(0);
        backgroundColor = generateColorByCode(firstLetterCode);
      }
    }

    return backgroundColor;
  };

  //list of random colors
  const colors = [
    "#3F51B5",
    "#2196F3",
    "#9F2B68",
    "#3F51B5",
    "#00A8FF",
    "#23c23b",
    "#FF5722",
    "#F44336",
    "#4CAF50",
    "#FF9800",
  ];

  const generateColorByCode = (code) => {
    let backgroundColor = "#15b4d4";
    if (code) {
      const codeNumber = code % 10;
      backgroundColor = colors[codeNumber];
    }
    return backgroundColor;
  };

  const renderContactLine = (details) => {
    return (
      <>
        <div className="contact-name-and-avatar">
          <div className="contact-avatar">
            {details && details.contact_list_favorite && (
              <div className="favorite-contact">
                <Icon name="star-solid" />
              </div>
            )}
            {details.contact_list_image ? (
              <Image
                src={
                  details && details.contact_list_image
                    ? details.contact_list_image
                    : null
                }
                name={!details.contact_list_image ? defaultAvatar : null}
                ext={!details.contact_list_image && "png"}
              />
            ) : (
              <div
                className="default-avatar-container"
                style={{
                  backgroundColor: calculateBackgroundColor(
                    details.contact_list_full_name
                      ? details.contact_list_full_name
                      : details.contact_list_email
                  ),
                }}
              >
                {getFirstTwoLettersOfEmail(
                  details.contact_list_full_name
                    ? details.contact_list_full_name
                    : details.contact_list_email
                )}
              </div>
            )}
          </div>
        </div>
        <div className="details-contact">
          <div className="contact-name">
            {details && details.contact_list_full_name
              ? details.contact_list_full_name
              : details.contact_list_email}
          </div>
          <div className="space">{" - "}</div>
          <div className="contact-email">
            {" "}
            {details && details.contact_list_email
              ? details.contact_list_email
              : null}
          </div>
        </div>
      </>
    );
  };

  const replaceTextNoResult = (text) => {
    let tempText = text;
    if (text.includes("#textSearching#")) {
      tempText = tempText.replace("#textSearching#", searchInput);
    }
    return tempText;
  };

  const openEditModal = (item) => {
    setModal({
      modal: ContactElementModal,
      modalSize: "full-modal",
      props: {
        isEdit: true,
        details: item,
        countFavoritesUsers,
        handleSubmit: handleEditSubmit,
        fromSearch: true,
      },
    });
  };

  const handleEditSubmit = (body, details) => {
    let newBody = { ...body };
    newBody.contactListId = details.contact_list_id;
    closeModal();
    cleanResult("");
    return ReactUpdateContact({
      formBody: newBody,
      setContactList: setContactList,
      contactList: contactList,
    });
  };

  return (
    <div className="search-contact-container">
      <div className="search-contact-content">
        <div className="search-input-container">
          <Icon iconClass="search-icon" name="search" />
          <div className="search-contact-input">
            <input
              value={searchInput}
              type="text"
              placeholder="Search"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </div>
          {searchInput && (
            <div className="search-contact-icon">
              {loadingSearch ? (
                <LoadingImageElement />
              ) : (
                <Icon onClick={() => searchOrClose()} name={iconSearch} />
              )}
            </div>
          )}
        </div>

        {successResultSearch && searchInput && <>{renderResultSearching()}</>}
      </div>
    </div>
  );
};

export default SearchContact;
